import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import Global from '../../../customlib/Global';
import { ExpandMore } from '@mui/icons-material';

class DetailKedisiplinanFuTeleMobile extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Kedisiplinan FU"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.dataKedisiplinan?.map((lead, index) => {
                            return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={4}>
                                            <Typography component="span">{Global.formatDateTimeToStrFormat(lead.tanggal, "DD-MM-YYYY")}</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"right"}>
                                            Sales<br />
                                            {lead.data.length}
                                        </Grid>
                                        <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                            Terlambat<br />
                                            {lead.totalTerlambat}
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Paper elevation={0} sx={{mb: "0px", padding: "5px"}}>
                                        {
                                            lead.data.map((item, index) => {
                                                return (
                                                    <Box>
                                                        <Grid container spacing={1} key={item.firstFu}>
                                                            <Grid item xs={12}>
                                                                <strong>{item.assignToUserName}</strong>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <strong>{item.fromName}</strong>
                                                            </Grid>
                                                            <Grid item xs={6} textAlign={"left"}>
                                                                FU Pertama<br />
                                                                <strong>{item.time_formatted}</strong>
                                                            </Grid>
                                                            <Grid item xs={6} textAlign={"right"}>
                                                                Status<br />
                                                                <div className={!item.isOnTime ? "text-danger" : ""}>
                                                                    <strong>{!item.isOnTime ? (<strong>TERLAMBAT</strong>) : "TEPAT WAKTU"}</strong> 
                                                                </div>
                                                            </Grid>
                                                            
                                                        </Grid>
                                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                                    </Box>
                                                );
                                            })
                                        }
                                        
                                    </Paper>
                                </AccordionDetails>
                            </Accordion>
                            );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default DetailKedisiplinanFuTeleMobile;